import React from "react";
import "./HomeContent.css";
import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Box, Button, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import QA from "./QA";
import Grid from "@mui/material/Grid";
import QARightSection from "./QARightSection";
import HowItWorks from "./HowItWorks";
import PostQuestionModal from "../PostQuestionModel/PostQuestionModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import {
  searchQuestionsAPI,
  setSearchText,
  clearSearchResults,
} from "../../store/searchSlice";
function HomeContent() {

  const [refreshQuestions, setRefreshQuestions] = useState(false);
  const [openPostModal, setOpenPostModal] = useState(false);
  
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  const bannerImg = process.env.PUBLIC_URL + "/images/Home/homebanner.png";
  const dispatch = useDispatch();
  const { searchText } = useSelector((state) => state.search);
  useEffect(() => {
    return () => {
      dispatch(clearSearchResults());
    };
  }, [dispatch]);
  useEffect(() => {
  const trimmedSearch = searchText.trim();

  if (!trimmedSearch) {
    dispatch(clearSearchResults());
    return;
  }

  if (trimmedSearch.length < 2) {
    return;
  }

  const delay = setTimeout(() => {
    dispatch(searchQuestionsAPI(trimmedSearch));
  }, 500);

  return () => clearTimeout(delay);
  }, [searchText, dispatch]);
  const handleSearchChange = (e) => {
  const value = e.target.value;
  dispatch(setSearchText(value));
  };
  return (
    <>
      <ThemeProvider theme={theme}>
        {/* Banner */}
        <div className="homebanner_container">
          <Slider {...settings}>

            {/* Slide 1 */}
            <div className="bannerSlide">
              <img src={bannerImg} alt="banner" className="homeBannerImg" />
              <div className="homebannerContentSection">
                <p>Community of Learning</p>
                <span>Empowering Learning, Collaboration, and Innovation</span>
              </div>
            </div>

            {/* Slide 2 (same for now) */}
            <div className="bannerSlide">
              <img src={bannerImg} alt="banner" className="homeBannerImg" />
              <div className="homebannerContentSection">
                <p>Community of Practices</p>
                <span>Empowering Learning, Collaboration, and Innovation</span>
              </div>
            </div>

          </Slider>
        </div>
        <Box sx={{width:"90%", margin:"auto"}}>
          <p className="note_para">Note: Please limit your posts to technical queries only. For training-related inquiries, kindly refer to the <a className="anchor_note" href="https://atc.l-tt.accenture.com/Learning-Calendar" target="_blank">Training Calendar</a>.</p>
        </Box>
        {/* Main Layout */}
        <Grid className="homeContainer">
        <Grid container spacing={2} sx={{ mt: 5 }} className="mainLayoutContainer">
          {/* 70% Section */}
          <Grid item xs={12} md={8} className="leftContainerGrid">
            <Box className="postqueSearchSection">
              {/* Left: Button */}
              <Box className="postButtonDisclaimerBox">
              <Button
                variant="contained"
                className="postQuestionBtn"
                    onClick={() => {
                      dispatch(clearSearchResults());
                      setOpenPostModal(true);
                    }}
              >
                Post Question
              </Button>
              {/* <Box className="disclaimerSection">
                <img
                  src={process.env.PUBLIC_URL + "/images/home/disclaimer_icon.png"}
                  alt="disclaimer"
                  className="disclaimerIcon"
                />
                <span className="disclaimerText">
                  Disclaimer: Please post only technical queries
                </span>
              </Box> */}
                </Box>
              {/* Right: Search */}
                <Box sx={{display:"flex", gap: "8%"}}>
                  {/* <Box className="divider" /> */}
                  <TextField
                    variant="standard"
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearchChange}
                    className="searchInput"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ fontSize: 18 }} />
                        </InputAdornment>
                      ),

                      endAdornment: searchText ? (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => dispatch(clearSearchResults())}
                          >
                            <CloseIcon fontSize="small" sx={{color:"black"}}/>
                          </IconButton>
                        </InputAdornment>
                      ) : null,

                      disableUnderline: false,
                    }}
                    inputProps={{
                      style: {
                        fontSize: "14px",
                      },
                    }}
                  />
                </Box>
             
            </Box>
            <QA refreshQuestions={refreshQuestions} />
          </Grid>

          {/* 30% Section */}
          <Grid item xs={12} md={4} className="rightContainerGrid">
            <QARightSection/>
          </Grid>
        </Grid>
        <Grid item xs={12} className="howItWorksContainer">
            <HowItWorks/>
          </Grid>
        </Grid>
      </ThemeProvider>
      <PostQuestionModal
        open={openPostModal}
        onClose={() => setOpenPostModal(false)}
        onPostSuccess={() => {
          dispatch(clearSearchResults());
          setRefreshQuestions((prev) => !prev);
        }}
      />
    </>
  );
}

export default HomeContent;
